// extracted by mini-css-extract-plugin
export default {"item":"CharacterPreview_item__xmuV2","item_header":"CharacterPreview_item_header__sVvHO","delete_icon":"CharacterPreview_delete_icon__qf4eO"};